import { NameDto } from 'api/Common/Types'

import { CurrencyType } from './Wallet'

export interface AggregateClientData {
  client: {
    id: string
    name: string
  }
  wallet: {
    id: string
    name: string
  }
  currency: {
    id: CurrencyType
    name: string
  }
  paymentProvider: {
    id: string
    name: string
  }
  transactionType: {
    id: number
    name: string
  }
  amount: number
  transactionCount: number
  lastDate: string
  externalAccounts: AggregateClientExternalAccount[]
}

export interface AggregateClientDataWithTotal {
  convertedDepositAmountTotal: number
  convertedWithdrawAmountTotal: number
  convertedAmountTotal: number
  convertedCurrency: NameDto
  items: AggregateClientData[]
}

interface AggregateClientExternalAccount {
  externalAccount: string
  amount: number
  transactionCount: number
  lastDate: string
  bankName?: string
}

export enum AggregateClientDataFilterKey {
  transactionState = 'transactionStateId',
}
